import React, { useEffect, useState } from "react";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { IoIosArrowRoundBack } from "react-icons/io";
import { TfiAngleDown, TfiAngleUp } from "react-icons/tfi";
import RestoImage1 from "../../../../helper/images/menuimage.png";
import { RiImageAddFill } from "react-icons/ri";
import { MdStar } from "react-icons/md";
import MenuImage from "../../../../helper/images/menuimage.png";
import VegIcon from "../../../../helper/svg/Veg.svg";
import NonVegIcon from "../../../../helper/svg/NonVeg.svg";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addMenucategory,
  addMenuItem,
  deleteMenuItem,
  getAllCategories,
  getMenuItems,
  updateMenuItem,
  deleteMenucategory,
  updateMenucategory,
  toggleCategoryStatus
} from "../../../../api/owner/hotels/menu";
import toast from "react-hot-toast";
import Pagination from "../../../../components/common/Pagination";
import { FiEdit, FiTrash } from "react-icons/fi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { getAllHotels } from "../../../../api/owner/hotels/rooms";
import { useTranslation } from "../../../../hooks/useTranslation";
import {  FiEye, FiEyeOff } from "react-icons/fi";

const AccordionSection = ({
  title,
  children,
  index,
  openIndex,
  setOpenIndex,
}) => {
  const isOpen = openIndex === index;

  const toggleAccordion = () => {
    setOpenIndex(isOpen ? null : index);
  };

  return (
    <div className="py-[25px] border-b border-[#DDDDDD] ">
      <div
        className="flex justify-between text-xl font-semibold cursor-pointer"
        onClick={toggleAccordion}
      >
        {title}
        <span>
          {isOpen ? <TfiAngleUp size={20} /> : <TfiAngleDown size={20} />}
        </span>
      </div>
      {isOpen && <div>{children}</div>}
    </div>
  );
};

const PopupModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
      <div className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[845px] relative sm:shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-[33px] right-[30px] text-[#9E9E9E] hover:text-black"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

const AddRestaurantMenu = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    hotelId: "",
    categoryName: "",
    name: "",
    description: "",
    price: "",
    foodType: "",
    image: null,
    categoryId: "",
    previewImage: null,
    manuId: "",
  });
  const [errors, setErrors] = useState({});
  const [page, setPage] = useState(1);
  const limit = 5;
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["hotel-menu-categories", formData.hotelId],
    queryFn: () => getAllCategories(formData.hotelId),
    keepPreviousData: true,
    enabled: !!formData.hotelId,
  });

  const { data: restaurantMenuData } = useQuery({
    queryKey: ["hotel-menu", formData.categoryId, page, limit],
    queryFn: () => getMenuItems(formData.categoryId, page, limit),
    keepPreviousData: true,
    enabled: !!formData.categoryId,
  });

  const { data: hotelData } = useQuery({
    queryKey: ["hotels-listing"],
    queryFn: () => getAllHotels({ limit: 1000 }),
    keepPreviousData: true,
  });

  const restaurants = hotelData?.data?.hotels || [];
  const categories = data?.data?.categories || [];
  const restaurantMenu = restaurantMenuData?.data?.items || [];
  const pagination = restaurantMenuData?.data?.pagination || {};

  const { mutate: addMenuCategoryMutation, loading } = useMutation({
    mutationFn: addMenucategory,
    onSuccess: () => {
      queryClient.invalidateQueries(["hotel-menu-categories"]);
      toast.success(t("addhotelmenu").menuCategoryAdded);
      setIsModalOpen(false);
      setFormData((prev) => ({ ...prev, categoryName: "" }));
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to add category. Please try again.";
      toast.error(errorMessage);
    },
  });

  const { mutate: addMenuItemMutation } = useMutation({
    mutationFn: addMenuItem,
    onSuccess: () => {
      queryClient.invalidateQueries(["hotel-menu-items"]);
      queryClient.invalidateQueries(["hotel-menu-categories"]);
      toast.success("Hotel menu item added successfully!");
      setFormData({
        ...formData,
        name: "",
        price: "",
        foodType: "",
        description: "",
        image: null,
        previewImage: null,
      });
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to add category. Please try again.";
      toast.error(errorMessage);
    },
  });

  const deletemenuItemMutation = useMutation({
    mutationFn: (menuId) => deleteMenuItem(menuId),
    onSuccess: () => {
      queryClient.invalidateQueries(["hotel-menu-items"]);
      queryClient.invalidateQueries(["hotel-menu-categories"]);
    },
  });

  const { mutate: updateMenuItemMutation } = useMutation({
    mutationFn: (data) => updateMenuItem(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["hotel-menu-items"]);
      toast.success(t("addhotelmenu").menuItemUpdated);
      closeModel();
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to update menu item. Please try again.";
      toast.error(errorMessage);
    },
  });


  const { mutate: updateMenuCategoryMutation, loading: isUpdateLoading } = useMutation({
    mutationFn: updateMenucategory,
    onSuccess: () => {
      queryClient.invalidateQueries(["hotel-menu-categories"]);
      toast.success(t("addhotelmenu").menuCategoryAdded);
      setIsModalOpen(false);
      setFormData((prev) => ({ ...prev, categoryName: "" }));
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        t("addhotelmenu").errors.addMenuCategory;
      toast.error(errorMessage);
    },
  });

  const { mutate: updateMenuVisibilityMutation, loading: isvisibilityLoading } = useMutation({
    mutationFn: toggleCategoryStatus,
    onSuccess: () => {
      queryClient.invalidateQueries(["hotel-menu-categories"]);
      // toast.success("Visibi");
      setIsModalOpen(false);
      setFormData((prev) => ({ ...prev, categoryName: "" }));
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        t("addhotelmenu").errors.addMenuCategory;
      toast.error(errorMessage);
    },
  });

  const deleteCategoryMutation = useMutation({
    mutationFn: (slotId) => deleteMenucategory(slotId),
    onSuccess: () => {
      queryClient.invalidateQueries(["hotel-menu-items"]);
      queryClient.invalidateQueries(["hotel-menu-categories"]);
    },
  });



  const handleUpdateCategory = (category) => {
    setFormData((prev) => ({
      ...prev,
      categoryName: category.category,
      hotelId: category.hotelId,
      categoryId: category._id,
    }));
    setIsEdit(true)
    setIsModalOpen(true);
  };


  const handleSaveCategory = async () => {
    if (!formData.categoryName || !formData.hotelId) {
      toast.error(t("addhotelmenu").errors.selectHotelCategory);
      return;
    }
    updateMenuCategoryMutation({
      hotelId: formData.hotelId,
      category: formData.categoryName,
      id: formData.categoryId
    });
  };

  const handleToggleCategory = async (item) => {
    updateMenuVisibilityMutation(item._id);
  };

  const handleDeleteCategory = (id) => {

    Swal.fire({
      title: t("addhotelmenu").confirmation.deleteTitle,
      text: t("addhotelmenu").confirmation.deleteText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("addhotelmenu").confirmation.deleteConfirm,
      cancelButtonText: t("addhotelmenu").confirmation.deleteCancel,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCategoryMutation.mutate(id, {
          onSuccess: () => {
            toast.success(t("addhotelmenu").menuCategoryDeleted);
          },
          onError: (error) => {
            const errorMessage =
              error?.response?.data?.message || "Failed to delete. Please try again.";
            toast.error(errorMessage);
          },
        });
      }
    });
  };

  useEffect(() => {
    if (openIndex) {
      setFormData((prev) => ({
        ...prev,
        categoryId: openIndex,
      }));
    }
  }, [openIndex]);

  // useEffect(() => {
  //   if (restaurants?.length > 0 && !formData.hotelId) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       hotelId: restaurants[0]._id,
  //     }));
  //   }
  // }, [restaurants]);

  const handleAddCategory = async () => {
    if (!formData.categoryName || !formData.hotelId) {
      toast.error(t("addhotelmenu").errors.selectHotelCategory);
      return;
    }
    addMenuCategoryMutation({
      hotelId: formData.hotelId,
      category: formData.categoryName,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name)
      newErrors.name = t("addhotelmenu").errors.itemNameRequired;
    if (!formData.price)
      newErrors.price = t("addhotelmenu").errors.priceRequired;
    else if (isNaN(formData.price))
      newErrors.price = t("addhotelmenu").errors.priceNumber;
    if (!formData.foodType)
      newErrors.foodType = t("addhotelmenu").errors.foodTypeRequired;
    return newErrors;
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (categoryId) => {
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (!formData.image) {
      toast.error("Select Image");
      return;
    }

    setErrors({});
    const data = new FormData();
    data.append("hotelId", formData.hotelId);
    data.append("category", formData.categoryId);
    data.append("itemName", formData.name);
    data.append("price", formData.price);
    data.append("foodType", formData.foodType);
    data.append("description", formData.description);
    if (formData.image) {
      data.append("images", formData.image);
    }

    addMenuItemMutation(data);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
        previewImage: URL.createObjectURL(file),
      }));
    }
  };

  const handleDeleteImage = () => {
    if (formData.previewImage && formData.previewImage.startsWith('blob:')) {
      URL.revokeObjectURL(formData.previewImage);
    }
    setFormData((prev) => ({
      ...prev,
      image: null,
      previewImage: null,
    }));
  };

  const onClickDelete = (menuId) => {
    const menuTranslations = t("addhotelmenu");
    const confirmation = menuTranslations?.confirmation || {};
    Swal.fire({
      title: confirmation.deleteTitle,
      text: confirmation.deleteText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmation.deleteConfirm,
      cancelButtonText: confirmation.deleteCancel || t("common")?.cancel || "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deletemenuItemMutation.mutate(menuId, {
          onSuccess: () => {
            toast.success(t("addhotelmenu").itemDeleted);
          },
          onError: (error) => {
            const errorMessage =
              error?.response?.data?.message ||
              t("addhotelmenu").errors.deleteItem;
            toast.error(errorMessage);
          },
        });
      }
    });
  };

  const onClickcancel = () => {
    const menuTranslations = t("addhotelmenu");
    const confirmation = menuTranslations?.confirmation || {};
    Swal.fire({
      title: confirmation.cancelTitle,
      text: confirmation.cancelText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmation.cancelConfirm,
      cancelButtonText: confirmation.deleteCancel || t("common")?.cancel || "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData((prev) => ({
          ...prev,
          name: "",
          description: "",
          price: "",
          foodType: "",
          image: null,
          previewImage: null,
        }));
      }
    });
  };

  const onUpdateClick = (item) => {
    setFormData((prev) => ({
      ...prev,
      name: item.itemName,
      price: item.price,
      description: item.description,
      foodType: item.foodType,
      previewImage: item?.images.length > 0 ? `${item.images[0]}` : null,
      manuId: item._id,
    }));
    setIsUpdateModalOpen(true);
  };

  const handleUpdate = () => {
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    const data = new FormData();
    data.append("hotelId", formData.hotelId);
    data.append("category", formData.categoryId);
    data.append("itemName", formData.name);
    data.append("price", formData.price);
    data.append("foodType", formData.foodType);
    data.append("description", formData.description);
    if (formData.image) {
      data.append("images", formData.image);
    }

    updateMenuItemMutation({ menuId: formData.manuId, data });
  };

  const closeModel = () => {
    setFormData((prev) => ({
      ...prev,
      name: "",
      description: "",
      price: "",
      foodType: "",
      image: null,
      previewImage: null,
      manuId: "",
    }));

    setIsUpdateModalOpen(false);
  };

  return (
    <>
      <div className="flex justify-between  flex-wrap gap-[20px]">
        <div className="flex gap-[10px] items-center">
          <div className="w-[32px] h-[32px] bg-[#4CAF50] rounded-[50%] flex items-center justify-center hover:bg-[#FF9D00]">
            <IoIosArrowRoundBack
              onClick={() => navigate(-1)}
              size={24}
              className="text-[#fff]"
            />
          </div>
          <h2 className="text-[22px] font-medium">
            {t("addhotelmenu").addMenuItems}
          </h2>
        </div>
        <div className="relative w-full sm:max-w-[220px] sm:ml-auto select-border">
          <select
            name="category"
            className="appearance-none bg-[#FF9D00] text-white rounded-[2px] py-[10px] px-[15px] w-full focus:outline-none focus:border-[#4CAF50] text-lg font-medium"
            value={formData.hotelId}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                hotelId: e.target.value,
              }))
            }
          >
            <option value="" selected>
              {t("addhotelmenu").selectHotel}
            </option>


            {restaurants?.map((restaurant) => (
              <option key={restaurant._id} value={restaurant._id}>
                {restaurant.name}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 bg-[#FF9D00]">
            <svg
              className="h-4 w-4 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>

        <div className="flex justify-center ">
          <button
            onClick={() => setIsModalOpen(true)}
            className="rounded-[2px] bg-[#4CAF50] text-white py-2 px-4"
          >
            {t("addhotelmenu").addMenuCategory}
          </button>
        </div>
      </div>

      <div className="mt-[12px] py-[22px] lg:px-[30px] md:px-[20px] px-[15px] bg-white  rounded-[16px] ">
        {categories?.length > 0 ? (
          categories?.map((item) => {
            return (
              <AccordionSection
                index={item?._id}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
                title={
                  <div className="flex justify-between items-center w-full me-3">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-black">
                        {item?.category} ({item?.totalMenuItems})
                      </span>
                    </div>

                    <div className="flex items-center gap-3">
                      {/* <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleToggleCategory(item)
                        }}
                        title="Edit Category"
                        className="text-blue-600 hover:text-blue-800"
                      >

                        {
                          item?.visibility ? <FiEye size={18} /> : <FiEyeOff size={18} />
                        }

                      </button> */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleUpdateCategory(item)
                        }}
                        title="Edit Category"
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <FiEdit size={18} />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteCategory(item?._id)
                        }}
                        title="Delete Category"
                        className="text-red-600 hover:text-red-800"
                      >
                        <FiTrash size={18} />
                      </button>
                    </div>
                  </div>
                }
              >
                <div className="flex flex-col md:gap-[24px] gap-[15px]">
                  <div className="grid grid-cols-1 xl:grid-cols-3 sm:grid-cols-2 md:gap-[30px_16px] gap-[15px] mt-[24px]">
                    <div>
                      <label className="text-sm text-[#000000] mb-[8px] block">
                        {t("addhotelmenu").itemName} 
                      </label>
                      <input
                        type="text"
                        placeholder={t("addhotelmenu").itemNamePlaceholder}
                        value={formData.name}
                        onChange={(e) => handleChange("name", e.target.value)}
                        className={`border ${errors.name ? "border-red-500" : "border-[#DDDDDD]"
                          } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
                      />
                      {errors.name && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.name}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="text-sm text-[#000000] mb-[8px] block">
                        {t("addhotelmenu").price} 
                      </label>
                      <input
                        type="number"
                        placeholder={t("addhotelmenu").pricePlaceholder}
                        value={formData.price}
                        onChange={(e) => handleChange("price", e.target.value)}
                        className={`border ${errors.price ? "border-red-500" : "border-[#DDDDDD]"
                          } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
                      />
                      {errors.price && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.price}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="text-sm text-[#000000] mb-[8px] block">
                        {t("addhotelmenu").foodType} 
                      </label>
                      <select
                        value={formData.foodType}
                        onChange={(e) =>
                          handleChange("foodType", e.target.value)
                        }
                        className={`border ${errors.foodType
                          ? "border-red-500"
                          : "border-[#DDDDDD]"
                          } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
                      >
                        <option value="" disabled>
                          {t("addhotelmenu").selectFoodType}
                        </option>
                        <option value="veg">{t("addhotelmenu").veg}</option>
                        <option value="non-veg">
                          {t("addhotelmenu").nonVeg}
                        </option>
                      </select>
                      {errors.foodType && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.foodType}
                        </p>
                      )}
                    </div>
                  </div>

                  <div>
                    <label className="text-sm text-[#000000] mb-[8px] block ">
                      {t("addhotelmenu").fullDescription}
                    </label>
                    <textarea
                      type="text"
                      value={formData.description}
                      placeholder={t("addhotelmenu").descriptionPlaceholder}
                      onChange={(e) =>
                        handleChange("description", e.target.value)
                      }
                      className={`border ${errors.description
                        ? "border-red-500"
                        : "border-[#DDDDDD]"
                        } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
                    />
                    {errors.description && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.description}
                      </p>
                    )}
                  </div>
                  <div className="flex gap-[10px] items-center">
                    <h2 className="text-base font-medium text-black">
                      {t("addhotelmenu").addPicture}
                    </h2>
                    <span className="w-full max-w-[28px] h-[28px] flex items-center justify-center bg-[#F2F2F2] rounded-[50%]">
                      <BsFillQuestionCircleFill
                        size={16}
                        className="text-[#404040]"
                      />
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-[16px] ">
                    <div className="relative">
                      <img
                        src={
                          formData.previewImage
                            ? formData.previewImage
                            : RestoImage1
                        }
                        alt=""
                        className="md:w-[200px] md:h-[120px] sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] object-cover sm:rounded-[16px] rounded-[4px] "
                      />
                      {formData.previewImage && (
                        <button
                          onClick={handleDeleteImage}
                          className="absolute top-1 right-1 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 flex items-center justify-center"
                          title="Delete image"
                        >
                          <FiTrash size={14} />
                        </button>
                      )}
                    </div>

                    <div className="bg-white p-5 border-dashed border-2  border-[#B9B9B9] rounded-[10px] text-center relative lg:w-[200px] lg:h-[120px] w-full h-[100px]  flex flex-col items-center justify-center cursor-pointer">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="opacity-0 absolute top-0 left-0 right-0 bottom-0 w-full h-full cursor-pointer"
                      />
                      <RiImageAddFill
                        size={24}
                        className="text-[#8C8C8C] mx-auto block"
                      />
                      <p className="text-sm font-medium mt-[14px]">
                        {t("addhotelmenu").addImage}
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-[21px] items-center md:flex-nowrap flex-wrap justify-between">
                    <div className="flex gap-[21px] items-center flex-wrap w-full">
                      <button
                        onClick={() => handleSubmit(item._id)}
                        className=" md:w-auto max-w-full inline-block w-full rounded-[2px] bg-[#4CAF50] text-[17px] text-white text-center font-bold py-[10px] px-[24px] green-shadow hover:bg-[#209b25]"
                      >
                        {t("addhotelmenu").update}
                      </button>
                      <button
                        onClick={onClickcancel}
                        className="md:w-auto max-w-full inline-block w-full rounded-[2px] bg-white text-[17px] border border-[#DDDDDD] text-center font-semibold py-[11px] px-[24px] text-black hover:bg-[#F2F2F2]"
                      >
                        {t("addhotelmenu").cancel}
                      </button>
                    </div>
                  </div>
                </div>

                {restaurantMenu?.length > 0 &&
                  restaurantMenu?.map((item) => {
                    return (
                      <div className="relative lg:items-center items-start justify-between bg-white border border-[#F1F1F1] rounded-[5px] lg:py-[10px] lg:pl-[11px] lg:pr-[20px] p-[15px] mt-[20px] menu-shadow">
                        <div className="absolute top-[15px] right-[15px] flex gap-2 z-10">
                          <button
                            onClick={() => onUpdateClick(item)}
                            title="Update"
                          >
                            <FiEdit
                              className="text-[#4CAF50] hover:text-[#388E3C]"
                              size={20}
                            />
                          </button>
                          <button
                            onClick={() => onClickDelete(item?._id)}
                            title="Delete"
                          >
                            <FiTrash
                              className="text-[#F44336] hover:text-[#D32F2F]"
                              size={20}
                            />
                          </button>
                        </div>

                        <div className="flex lg:gap-[47px] md:flex-nowrap flex-wrap gap-[10px]">
                          <img
                            src={
                              item?.images?.length > 0
                                ? `${item.images[0]}`
                                : MenuImage
                            }
                            className="md:max-w-[300px] max-w-[91px] xl:h-full rounded-[5px] object-cover"
                            alt="Menu"
                          />
                          <div className="">
                            {item?.foodType === "veg" ? (
                              <img src={VegIcon} alt="Veg Icon" />
                            ) : (
                              <img src={NonVegIcon} alt="Veg Icon" />
                            )}

                            <h3 className="font-semibold lg:text-[30px] md:text-[25px] text-lg text-black md:my-[15px] mt-[5px]">
                              {item?.itemName}
                            </h3>

                            <div className="flex items-center lg:gap-[37px] gap-[6px] md:mt-3 mt-[5px] max-w-[259px]">
                              <span className="lg:text-[22px] text-base font-medium text-black">
                                ₾{item?.price}
                              </span>
                              <div className="flex items-center md:gap-[15px] gap-[9px]">
                                <div className="flex items-center">
                                  {[...Array(5)].map((_, i) => (
                                    <MdStar
                                      key={i}
                                      size={21}
                                      className="text-[#FF9D00]"
                                    />
                                  ))}
                                </div>
                                <p className="text-[#4CAF50] text-[14px] font-medium">
                                  4.3 (7)
                                </p>
                              </div>
                            </div>

                            <p className="md:text-lg text-[15px] text-[#848484] md:mt-[19px] mt-[15px] md:leading-[30px] leading-6">
                              {item?.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                {restaurantMenu?.length > 0 && (
                  <Pagination
                    page={pagination.page}
                    totalPages={pagination.totalPages}
                    setPage={setPage}
                  />
                )}
              </AccordionSection>
            );
          })
        ) : (
          <div className="flex justify-center mt-10">
            <div className=" text-[#856404] px-6 py-3 rounded-md   text-lg font-semibold tracking-wide">
              {t("addhotelmenu").noMenuItems}
            </div>
          </div>
        )}
      </div>

      <PopupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-[400px]">
            <h2 className="text-lg font-semibold mb-4">
               {isEdit ? "Update" : t("addrestaurantmenu").addMenuCategory}
            </h2>

            <div className="mb-4">
              <label className="text-sm font-medium">
                {t("addhotelmenu").categoryName}
              </label>
              <input
                type="text"
                value={formData.categoryName}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    categoryName: e.target.value,
                  }))
                }
                placeholder={t("addhotelmenu").categoryNamePlaceholder}
                className="border border-[#DDDDDD] rounded-[10px] p-[10px] w-full"
              />
            </div>

            <div className="flex gap-[20px] justify-end pt-[23px] border-t border-[#EEEEEE]">
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-white font-bold py-[10px] px-[20px] rounded-[2px] bg-[#CCCCCC] hover:bg-[#B8B8B8] text-base text-center gray-shadow"
              >
                {t("addhotelmenu").cancel}
              </button>
              <button
                onClick={isEdit ? handleSaveCategory : handleAddCategory}
                className="rounded-[2px] bg-[#4CAF50] text-base text-white font-bold py-[10px] px-[20px] green-shadow hover:bg-[#209b25]"
              >
                {t("addhotelmenu").update}
              </button>
            </div>
          </div>
        </div>
      </PopupModal>

      <PopupModal isOpen={isUpdateModalOpen} onClose={closeModel}>
        <div className="w-full rounded-[20px] sm:p-[30px] p-[15px]">
          <h2 className="text-[22px] font-medium mb-[19px]">Update</h2>
          <div className="flex flex-col md:gap-[24px] gap-[15px]">
            <div className="grid grid-cols-1 xl:grid-cols-3 sm:grid-cols-2 md:gap-[30px_16px] gap-[15px] mt-[24px]">
              <div>
                <label className="text-sm text-[#000000] mb-[8px] block">
                  {t("addhotelmenu").itemName} *
                </label>
                <input
                  type="text"
                  placeholder={t("addhotelmenu").itemNamePlaceholder}
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                  className={`border ${errors.name ? "border-red-500" : "border-[#DDDDDD]"
                    } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>

              <div>
                <label className="text-sm text-[#000000] mb-[8px] block">
                  {t("addhotelmenu").price} *
                </label>
                <input
                  type="number"
                  placeholder={t("addhotelmenu").pricePlaceholder}
                  value={formData.price}
                  onChange={(e) => handleChange("price", e.target.value)}
                  className={`border ${errors.price ? "border-red-500" : "border-[#DDDDDD]"
                    } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
                />
                {errors.price && (
                  <p className="text-red-500 text-sm mt-1">{errors.price}</p>
                )}
              </div>

              <div>
                <label className="text-sm text-[#000000] mb-[8px] block">
                  {t("addhotelmenu").foodType} *
                </label>
                <select
                  value={formData.foodType}
                  onChange={(e) => handleChange("foodType", e.target.value)}
                  className={`border ${errors.foodType ? "border-red-500" : "border-[#DDDDDD]"
                    } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
                >
                  <option value="" disabled>
                    {t("addhotelmenu").selectFoodType}
                  </option>
                  <option value="veg">{t("addhotelmenu").veg}</option>
                  <option value="non-veg">{t("addhotelmenu").nonVeg}</option>
                </select>
                {errors.foodType && (
                  <p className="text-red-500 text-sm mt-1">{errors.foodType}</p>
                )}
              </div>
            </div>

            <div>
              <label className="text-sm text-[#000000] mb-[8px] block ">
                {t("addhotelmenu").fullDescription}
              </label>
              <textarea
                type="text"
                value={formData.description}
                placeholder={t("addhotelmenu").descriptionPlaceholder}
                onChange={(e) => handleChange("description", e.target.value)}
                className={`border ${errors.description ? "border-red-500" : "border-[#DDDDDD]"
                  } rounded-[10px] p-[15px] w-full focus:outline-none focus:border-[#4CAF50]`}
              />
              {errors.description && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.description}
                </p>
              )}
            </div>
            <div className="flex gap-[10px] items-center">
              <h2 className="text-base font-medium text-black">{t("addhotelmenu").addPicture}</h2>
              <span className="w-full max-w-[28px] h-[28px] flex items-center justify-center bg-[#F2F2F2] rounded-[50%]">
                <BsFillQuestionCircleFill
                  size={16}
                  className="text-[#404040]"
                />
              </span>
            </div>
            <div className="flex flex-wrap gap-[16px] ">
              <div className="relative">
                <img
                  src={
                    formData.previewImage ? formData.previewImage : RestoImage1
                  }
                  alt=""
                  className="md:w-[200px] md:h-[120px] sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] object-cover sm:rounded-[16px] rounded-[4px] "
                />
                {formData.previewImage && (
                  <button
                    onClick={handleDeleteImage}
                    className="absolute top-1 right-1 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 flex items-center justify-center"
                    title="Delete image"
                  >
                    <FiTrash size={14} />
                  </button>
                )}
              </div>

              <div className="bg-white p-5 border-dashed border-2  border-[#B9B9B9] rounded-[10px] text-center relative lg:w-[200px] lg:h-[120px] w-full h-[100px]  flex flex-col items-center justify-center cursor-pointer">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="opacity-0 absolute top-0 left-0 right-0 bottom-0 w-full h-full cursor-pointer"
                />
                <RiImageAddFill
                  size={24}
                  className="text-[#8C8C8C] mx-auto block"
                />
                <p className="text-sm font-medium mt-[14px]">
                  {t("addhotelmenu").addImage}
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-[20px] justify-end pt-[23px] border-t border-[#EEEEEE]">
            <button
              onClick={closeModel}
              className="text-white font-bold py-[10px] px-[20px] rounded-[2px] bg-[#CCCCCC] hover:bg-[#B8B8B8] text-base text-center gray-shadow"
            >
              {t("addhotelmenu").cancel}
            </button>
            <button
              onClick={handleUpdate}
              className="rounded-[2px] bg-[#4CAF50] text-base text-white font-bold py-[10px] px-[20px] green-shadow hover:bg-[#209b25]"
            >
              {t("addhotelmenu").saveChanges}
            </button>
          </div>
        </div>
      </PopupModal>
    </>
  );
};

export default AddRestaurantMenu;
